import { useEffect } from 'react'
import { useAuth } from '../hooks/useAuth'
import { LoadingScreen } from '@/components/common/feedback/LoadingScreen'

export function SignOut() {
  const { signOut } = useAuth()

  useEffect(() => {
    signOut()
  }, [signOut])

  return <LoadingScreen />
}

